import { render, staticRenderFns } from "./ReuploadBook.vue?vue&type=template&id=81a99dd2&"
import script from "./ReuploadBook.vue?vue&type=script&lang=js&"
export * from "./ReuploadBook.vue?vue&type=script&lang=js&"
import style0 from "./ReuploadBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports